module.exports = __webpack_public_path__ + "img/hero-our-plan@2x.c4aa0f4f.jpg";